import { UserRoleType } from '@/api';

export const AccessControlAction = {
  VIEW_USER_MANAGEMENT_TAB: 'viewUserManagementTab',
  ADD_EDIT_USERS: 'addEditUsers',
  GLOBAL_ADMIN_ONLY: 'globalAdminOnly',
  DELETE_CASE: 'deleteCase',
  EDIT_CASE_SETTINGS: 'editCaseSettings',
  MANAGE_ANY_PROJECT: 'manageAnyProject',
} as const;

export type AccessControlAction = (typeof AccessControlAction)[keyof typeof AccessControlAction];

export type AccessControlMatrix = Record<UserRoleType, Record<AccessControlAction, boolean>>;

// Users granted access to the Admin tools tab without being global admins,
// as a global admin role would let them see data from other orgs.
export const ADMIN_TOOLS_ALLOWED_USER_IDS: string[] = [
  '83908237-c3cd-4453-8552-1abfe89a8270',
  '9fa93dfe-4816-40d5-84cc-90f7ccf20ff5',
  '18059999-44cf-4d12-ac23-fed7e85ca24d',
  '17bc9eaf-fa53-4623-8e14-69878ef999d6',
  '0add2808-9803-4f68-b528-48e217ee268d',
];

export const ACTIONS_ALLOWED_USER_IDS: string[] = [
  '83908237-c3cd-4453-8552-1abfe89a8270',
  '9fa93dfe-4816-40d5-84cc-90f7ccf20ff5',
  '18059999-44cf-4d12-ac23-fed7e85ca24d',
  '17bc9eaf-fa53-4623-8e14-69878ef999d6',
  '0add2808-9803-4f68-b528-48e217ee268d',
  '1ea0e241-f20c-40b3-b93a-c254e057adaa',
];

export const OOM_REVIEW_ALLOWED_USER_IDS: string[] = [
  '199c79a9-a747-477f-b0fb-935611577397',
  '1ea0e241-f20c-40b3-b93a-c254e057adaa',
  '0add2808-9803-4f68-b528-48e217ee268d',
  '17bc9eaf-fa53-4623-8e14-69878ef999d6',
];

export const ACCESS_CONTROL_MATRIX: AccessControlMatrix = {
  [UserRoleType.GLOBAL_ADMIN]: {
    viewUserManagementTab: true,
    addEditUsers: true,
    globalAdminOnly: true,
    deleteCase: true,
    editCaseSettings: true,
    manageAnyProject: true,
  },
  [UserRoleType.ADMIN]: {
    viewUserManagementTab: true,
    addEditUsers: true,
    globalAdminOnly: false,
    deleteCase: true,
    editCaseSettings: true,
    manageAnyProject: true,
  },
  [UserRoleType.LAWYER]: {
    viewUserManagementTab: false,
    addEditUsers: false,
    globalAdminOnly: false,
    deleteCase: false,
    editCaseSettings: false,
    manageAnyProject: false,
  },
};
